import { render } from "./anc_profile.vue?vue&type=template&id=fa96381a&scoped=true"
import script from "./anc_profile.vue?vue&type=script&lang=js"
export * from "./anc_profile.vue?vue&type=script&lang=js"

import "./anc_profile.vue?vue&type=style&index=0&id=fa96381a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa96381a"]])

export default __exports__